import { c as _c } from "react/compiler-runtime";
import { ListItem } from '@7f-ui/components/list/list';
import { Radio } from '@7f-ui/components/radio/radio';
import { RadioGroup } from '@headlessui/react';
import { shopTestId } from '@utils/utils-shop-test-ids';
import { useState } from 'react';
type AppVariantSelectProps = {
  initialSelectedVariant?: string;
  variants: {
    id: string;
    title: string;
    subline?: string;
  }[];
  onChange: (variantId: string) => void;
};
export function AppVariantSelect(t0) {
  const $ = _c(13);
  const {
    initialSelectedVariant,
    variants,
    onChange
  } = t0;
  const [selectedVariant, setSelectedVariant] = useState(initialSelectedVariant);
  let t1;
  if ($[0] !== onChange) {
    t1 = variantId => {
      setSelectedVariant(variantId);
      onChange(variantId);
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onVariantChange = t1;
  let t2;
  if ($[2] !== onVariantChange || $[3] !== selectedVariant || $[4] !== variants) {
    let t3;
    if ($[6] !== onVariantChange || $[7] !== selectedVariant) {
      t3 = t4 => {
        const {
          id: variantId_0,
          title,
          subline
        } = t4;
        return <ListItem key={variantId_0} variant="extended" selected={selectedVariant === variantId_0} renderIconEnd={() => <Radio value={variantId_0} static={true} />} subline={subline} onClick={() => onVariantChange(variantId_0)} data-testid={shopTestId("VariantSelect.item")}>{title}</ListItem>;
      };
      $[6] = onVariantChange;
      $[7] = selectedVariant;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = variants.map(t3);
    $[2] = onVariantChange;
    $[3] = selectedVariant;
    $[4] = variants;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== onVariantChange || $[10] !== selectedVariant || $[11] !== t2) {
    t3 = <RadioGroup value={selectedVariant} onChange={onVariantChange} as="ul">{t2}</RadioGroup>;
    $[9] = onVariantChange;
    $[10] = selectedVariant;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}